import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { cloneDeep } from 'lodash';
import { CountryService, SimpleCountry } from '@app/origami-api/services/country.service';
import { OrigamiResponse } from '@app/origami-api/services/base/service.base';

type CountryResponse = OrigamiResponse<SimpleCountry[]>;

@Injectable({
  providedIn: 'root',
})
export class AllCountriesService {
  private allCountriesCache: CountryResponse;

  constructor(private readonly countryService: CountryService) {}

  getAllCountries(): Observable<CountryResponse> {
    if (this.allCountriesCache) {
      return of(this.allCountriesCache);
    }
    return this.countryService.getAllCountries().pipe(
      tap((response) => {
        this.allCountriesCache = cloneDeep(response);
      }),
    );
  }
}
